export default __webpack_public_path__ + "static/media/SocialLeft.8c05439a.svg";